import { render, staticRenderFns } from "./LiveOps.vue?vue&type=template&id=96469988&scoped=true"
import script from "./LiveOps.vue?vue&type=script&lang=js"
export * from "./LiveOps.vue?vue&type=script&lang=js"
import style0 from "./LiveOps.vue?vue&type=style&index=0&id=96469988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96469988",
  null
  
)

export default component.exports